export default {
    "db": "Đang bán",
    "nb": "Ngừng bán",
}
